export default "__VITE_ASSET__BBmpq6nH__"